export function getDeviceId() {
  let id = localStorage.getItem('queuebar_device_id');
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem('queuebar_device_id', id);
  }
  return id;
}
